import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/internal-marks")({
  beforeLoad: () => {
    throw redirect({
      to: "/results",
    });
  },
});
